import React from 'react';
import PropTypes from 'prop-types';
import { NotFound } from 'cccisd-laravel-boilerplate';
import { withRouter, Redirect } from 'react-router-dom';
import _find from 'lodash/find';
import { findNav } from 'cccisd-laravel-appdefs';

var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var AppDefs = window.cccisd.appDefs;

export default withRouter(
    class AuthRedirect extends React.Component {
        static propTypes = {
            location: PropTypes.object,
            match: PropTypes.object,
            history: PropTypes.object,

            /**
             * This components also handles showing the 404 page.
             * We pass this prop when we know we want to show the 404 page
             */
            isComponentOnly: PropTypes.bool,
        };

        render() {
            let content = 'Redirecting....';

            if (!Fortress.auth()) {
                window.location =
                    this.props.history.location.pathname === '/'
                        ? Boilerplate.url(`/login`)
                        : Boilerplate.url(`/login${this.props.history.location.pathname}`);
            }

            if (Fortress.auth()) {
                let nav = findNav(AppDefs.navs, AppDefs.routes);
                let homepageRoute = _find(AppDefs.routes, r => r.handle === nav.homepage);
                // if this is not a pass-through display default 404 page
                if (this.props.isComponentOnly) {
                    content = <NotFound />;
                } else if (homepageRoute) {
                    if (homepageRoute.url.includes('https')) {
                        window.location = homepageRoute.url;
                    } else {
                        content = (
                            <Redirect
                                to={{
                                    pathname: homepageRoute.url,
                                }}
                            />
                        );
                    }
                } else {
                    content = (
                        <Redirect
                            to={{
                                pathname: '/',
                            }}
                        />
                    );
                }
            }

            return <div>{content}</div>;
        }
    }
);
